/* SHEET-01 (2026-10-08): one side sheet, shared by PDP detail rows (right) and the collection filter (left).
   window.szSheet.open({ title, side, content }) moves `content` (a DOM node) into the sheet and returns it to its
   original place on close. Declarative: any element with data-sz-sheet-open="#id" opens that node;
   data-sz-sheet-side and data-sz-sheet-title are optional. */
(function () {
  'use strict';
  var sheet = document.querySelector('[data-sz-sheet]');
  if (!sheet || window.szSheet) return;
  var panel = sheet.querySelector('.sz-pm-sheet__panel'), body = sheet.querySelector('[data-sz-sheet-body]'), title = sheet.querySelector('.sz-pm-sheet__title');
  var current = null, marker = null, returnFocus = null, wasHidden = false;

  /* Overflow lock on <html>: no position:fixed, so nothing to restore and no jump on close (html has scroll-behavior:smooth). */
  function lock() { var sw = window.innerWidth - document.documentElement.clientWidth; document.documentElement.classList.add('sz-pm-sheet-open'); if (sw > 0) document.documentElement.style.paddingRight = sw + 'px'; }
  function unlock() { document.documentElement.classList.remove('sz-pm-sheet-open'); document.documentElement.style.paddingRight = ''; }

  function open(opts) {
    opts = opts || {};
    var node = typeof opts.content === 'string' ? document.querySelector(opts.content) : opts.content;
    if (!node) return false;
    if (current && current !== node) close(true);
    if (current !== node) {
      marker = document.createComment('sz-sheet-home');
      node.parentNode.insertBefore(marker, node);
      wasHidden = node.hidden;
      body.appendChild(node);
      node.hidden = false;
      current = node;
    }
    title.textContent = opts.title || node.getAttribute('data-sheet-title') || '';
    sheet.setAttribute('data-side', opts.side === 'left' ? 'left' : 'right');
    returnFocus = document.activeElement;
    sheet.hidden = false;
    lock();
    setTimeout(function () { sheet.classList.add('is-open'); body.scrollTop = 0; panel.focus({ preventScroll: true }); }, 16);
    return true;
  }

  function close(silent) {
    if (!current) { sheet.hidden = true; return; }
    sheet.classList.remove('is-open');
    var node = current, home = marker, rehide = wasHidden; current = null; marker = null; wasHidden = false;
    var finish = function () {
      if (home && home.parentNode) { home.parentNode.insertBefore(node, home); home.parentNode.removeChild(home); }
      if (rehide) node.hidden = true;
      if (!current) { sheet.hidden = true; unlock(); }
      if (!silent && returnFocus && returnFocus.focus) returnFocus.focus({ preventScroll: true });
    };
    /* RIPPLE-01: the panel now glides out over 0.5 s (assets/sz-pm-fixes.css), so it is put away after that */
    if (silent) finish(); else setTimeout(finish, matchMedia('(prefers-reduced-motion: reduce)').matches ? 220 : 520);
  }

  sheet.addEventListener('click', function (e) { if (e.target.closest('[data-sz-sheet-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) { e.preventDefault(); close(); } });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sz-sheet-open]'); if (!b) return;
    var target = document.querySelector(b.getAttribute('data-sz-sheet-open')); if (!target) return;
    e.preventDefault();
    open({ content: target, side: b.getAttribute('data-sz-sheet-side') || 'right', title: b.getAttribute('data-sz-sheet-title') || b.textContent.trim() });
  });
  /* keep Tab inside the panel */
  panel.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  window.szSheet = { open: open, close: close, isOpen: function () { return !sheet.hidden; } };
  document.dispatchEvent(new CustomEvent('sz-sheet-ready'));
})();
